import styled from "@emotion/styled";
import { Button, Form, message, Modal, Select, Typography } from "antd";
import { FC, useState } from "react";
import OrderTableList from "./OrderTableList";
import { PlusOutlined } from "@ant-design/icons";
import { ParkingListItems } from "services/interface";
import DescriptionForm from "./DescriptionForm";
import { useCreateParking, useDeleteParking, useGetParkingById, useUpdateParking } from "hooks/useShipping";
import { useAppSelector } from "store";
const { Option } = Select;

interface ModalCreateDeliveryPointProps {
  id: string;
  data: ParkingListItems[] | undefined;
  open: boolean;
  onClose: () => void;
  refetch: (id: string) => void;
}

const ModalCreateDeliveryPoint: FC<ModalCreateDeliveryPointProps> = ({ data, open, onClose , id, refetch}) => {
  const [showDetail, setShowDetail] = useState(false);
  const [updateDetail, setUpdateDetail] = useState(false);

  const [idUpd, setIdUpd] = useState('');
  
  const [form] = Form.useForm();

  const factoryId = useAppSelector((state) => state.auth.profile?.user?.role?.ref_id);

  const { mutate:CreateParking } = useCreateParking();
  const { mutate:DeleteParking } = useDeleteParking();
  const { mutate:UpdateParking } = useUpdateParking();
  const { mutate:ParkingById } = useGetParkingById();

  const onCloseUpdate = () => {
    form.resetFields();
    setUpdateDetail(false);
    setIdUpd('');
  }


  const onCloseModal = () => {
    form.resetFields();
    setShowDetail(false);
  }

  const onFinish = (values: any) => {
    console.log(values);
    CreateParking({
      factory_id: factoryId || '',
      master_transport_id: id,
      name: values.name,
    }, {
      onSuccess: (res) => {
        if (res.status === "success") {
          message.success("สร้างสำเร็จ");
          refetch(id);
          onCloseModal();
        } else {
          message.error(`สร้างไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        message.error(`สร้างไม่สำเร็จ: ${error.message}`);
      },
    });
  };

  const onDeleteData = (parkingId: string) => {
    DeleteParking({
      id: parkingId
    }, {
      onSuccess: (res) => {
        if (res.status === "success") {
          message.success("ลบสำเร็จ");
          refetch(id);
        } else {
          message.error(`ลบไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        message.error(`ลบไม่สำเร็จ: ${error.message}`);
      },
    });
  }



  const onEditData = (parkingId: string) => {
    ParkingById(parkingId, {
      onSuccess: (res) => {
        if (res.status === "success") {
          setIdUpd(parkingId);
          setUpdateDetail(true);
          form.setFieldsValue({name: res.data.name})
        } else {
          // message.error(`ลบไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        // message.error(`ลบไม่สำเร็จ: ${error.message}`);
      },
    });
  }

  const onUpdate = (values: any) => {
    console.log(values);
    UpdateParking({
      id: idUpd,
      factory_id: factoryId || '',
      master_transport_id: id,
      name: values.name,
    }, {
      onSuccess: (res) => {
        if (res.status === "success") {
          message.success("แก้ไขสำเร็จ");
          refetch(id);
          onCloseUpdate();
        } else {
          message.error(`แก้ไขไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        message.error(`แก้ไขไม่สำเร็จ: ${error.message}`);
      },
    });
  };
  return (
    <>
      <Modal
        title="รายการจุดส่งสินค้า"
        open={open}
        width={1000}
        maskClosable={false}
        onCancel={onClose}
        style={{ top: 20 }}
        footer={null}
        // footer={[
        //   <Button key="back" onClick={onClose}>
        //     ยกเลิก
        //   </Button>,
        //   <Button key="submit" type="primary" onClick={() => form.submit()}>
        //     บันทึก
        //   </Button>,
        // ]}
      >
        <WrapperAll>
          <HeadWrapper>
            <ButtonWrapper>
              <StyledButton
                type="primary"
                onClick={() => {
                  setShowDetail(true);
                }}
              >
                <PlusOutlined /> เพิ่มแถวรายการ
              </StyledButton>
            </ButtonWrapper>
          </HeadWrapper>
          <OrderTableList data={data} onDeleteData={onDeleteData} onEditData={onEditData} />
        </WrapperAll>

        <Modal
          title="เพิ่มจุดส่งสินค้า"
          open={showDetail}
          maskClosable={false}
          onCancel={() => {
            onCloseModal();
          }}
          // onOk={() => form.submit()}
          style={{ top: 20 }}
          footer={[
            <Button key="back" onClick={() => onCloseModal()}>
              ยกเลิก
            </Button>,
            <Button key="submit" type="primary" onClick={() => form.submit()}>
              บันทึก
            </Button>,
          ]}
        >
          <WrapperAll>
            <Form form={form} onFinish={onFinish}>
              <DescriptionForm form={form} />
            </Form>
          </WrapperAll>
        </Modal>

        <Modal
          title="แก้ไขจุดส่งสินค้า"
          open={updateDetail}
          maskClosable={false}
          onCancel={() => {
            onCloseUpdate();
          }}
          // onOk={() => form.submit()}
          style={{ top: 20 }}
          footer={[
            <Button key="back" onClick={() => onCloseUpdate()}>
              ยกเลิก
            </Button>,
            <Button key="submit" type="primary" onClick={() => form.submit()}>
              บันทึก
            </Button>,
          ]}
        >
          <WrapperAll>
            <Form form={form} onFinish={onUpdate}>
              <DescriptionForm form={form} />
            </Form>
          </WrapperAll>
        </Modal>
        
      </Modal>
    </>
  );
};

export default ModalCreateDeliveryPoint;

const StyledButton = styled(Button)`
  margin-right: 5px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0px 10px 0px 10px;
  margin-bottom: 10px;
  margin-top: 10px;

  & > :first-child {
    flex: 3;
  }

  & > :last-child {
    flex: 7;
    display: flex;
    justify-content: flex-end;
  }
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
